export default {
  data() {
    return {
      loading: false,
      filterText: '',
      filterCustomSensorText: '',
      reports: [],
      location: [],
      deviceGroups: [],
      defaultProps: {
        children: 'children',
        label: 'Name'
      },
      deviceGroupProps: {
        children: 'children',
        label: 'Name'
      },
      cascaderProps: {
        multiple: true
      },
      periodDatePickerType: 'date',
      datePickerOptions: '',
      customSensorList: [],
      customerList: []
    }
  },
  mounted() {},
  methods: {
    allowAlarmReport() {
      return (
        this.user.RolesName.includes('Customer Admin') ||
        this.user.RolesName.includes('Customer Staff')
      )
    },
    onChangePicker() {
      if (this.form.dataForm == 'monthly') this.periodDatePickerType = 'month'
      else if (this.form.dataForm == 'yearly')
        this.periodDatePickerType = 'year'
      else this.periodDatePickerType = 'date'

      this.form.startDate = ''
      this.form.endDate = ''
    },
    validateDate() {
      if (this.form.startDate != '' && this.form.endDate != '') {
        let temp1 = new Date(this.form.startDate)
        let temp2 = new Date(this.form.endDate)
        if (temp1 > temp2) {
          this.form.endDate = ''
          this.$message.error('End Period must be greater than Start Period')
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return data.Name.indexOf(value) !== -1
    },
    filterCustomSensor(value, data) {
      if (!value) return true
      return data.VarName.indexOf(value) !== -1
    },
    onDeviceGroupChange(data, checked) {
      // skip parent data
      if (data.children.length) return
      if (checked) {
        // populate formula
        if (data.IsFormula && !this.form.ListFormula.includes(data.Dce_id)) {
          this.form.ListFormula.push(data.Dce_id)
        }
      } else {
        // populate formula
        if (data.IsFormula) {
          this.form.ListFormula = this.form.ListFormula.filter(
            (x) => x !== data.Dce_id
          )
        }
      }
    },
    findDeviceGroupDataByKey(deviceGroups, key, value) {
      for (var deviceGroup of deviceGroups) {
        if (deviceGroup[key] == value) {
          return deviceGroup
        } else {
          return this.findDeviceGroupDataByKey(deviceGroup.children, key, value)
        }
      }
    },
    sensorDataChange(data, checked) {
      this.$emit('sensorDataSelected', {
        data: data,
        checked: checked
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()

      // reset parameter
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'customer')) {
        this.$router.push({
          query: Object.assign({}, [], [])
        })
      }
    },
    setDefaultCustomerId() {
      if (this.isCustomer) {
        this.form.customer = this.user.CustomerName
          ? this.user.CustomerName[0]
          : ''
      }
    },
    closePopup(val) {
      this.popupScheduleOpen = !val
    },
    setAllFormulaIds(data) {
      var _this = this

      // set disability
      return data.map(function (item) {
        // populate formula
        if (item.IsFormula) {
          _this.form.ListFormula.push(item.Dce_id)
        }

        // find on children data
        if (item.children.length) {
          _this.setAllFormulaIds(item.children)
        }
        return item
      })
    },
    onLocationChanged(val) {
      // extract nested location array
      this.form.locationReport = Array.isArray(val)
        ? val.map(function (x) {
            return Array.isArray(x) ? x[0] : x
          })
        : val

      this.getCustomers(this.form.locationReport)
    },

    async submitFilter(fromUrl = false) {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (!fromUrl) {
            // push parameter
            this.$router.push({
              query: Object.assign({}, this.$route.query, this.form)
            })
          }

          this.$emit('formData', this.form)
        } else {
          this.$message.warning('Please fill in the Report filters correctly')
        }
      })
    },
    async getLocations() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.manualConfig.getListServerLocation
        )

        // get location
        this.location = res.data.map(function (x) {
          x.disabled = x.value !== 'ONEDC'
          return x
        })

        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async getCustomers(locationIds) {
      try {
        this.loading = true
        const res = await this.$axios.post(
          this.$appInfo.api.customer.getListCustomerByMultipleServerCode,
          {
            ListServerCode: locationIds
          }
        )
        this.customerList = res.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async getSensorsByCustomers(CustomerDcoId) {
      try {
        this.loading = true
        const res = await this.$axios.get(
          //this.$appInfo.api.reportTree.getCustTreeSensorFiltered + '?CustomerDcoId=' + CustomerDcoId + '&Filter=ENERGY'
          this.$appInfo.api.treeGroupDevice
            .getCustTreeGroupDeviceLevelWithFormula +
            '?CustomerDcoId=' +
            CustomerDcoId +
            '&Tags=' +
            this.form.reportType
        )

        // set deviceGroups
        this.deviceGroups = res.data

        // reset & set all formula ids
        this.form.ListFormula = []
        this.setAllFormulaIds(this.deviceGroups)

        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async getCustomSensors() {
      try {
        this.loading = true
        const res = await this.$axios.get(this.$appInfo.api.formula.getAll)
        this.customSensorList = res.data.map(function (item) {
          item.label = item.VarName
          return item
        })
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async getReportTypes() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.tag.listStringTagsAuthorizeReport
        )
        this.reports = this.allowAlarmReport()
          ? res.data.filter((x) => x != 'Alarm Report')
          : res.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    }
  },
  computed: {
    isCustomer() {
      return this.$store.state.auth.isCustomer
    },
    user() {
      return this.$store.state.auth.userData
    }
  },
  watch: {
    filterText(val) {
      this.$refs.deviceGroupsTree.filter(val)
    },
    filterCustomSensorText(val) {
      this.$refs.customerSensorTree.filter(val)
    },
    'form.customer': function (val) {
      if (val) {
        // fetch customer sensors
        this.getSensorsByCustomers(val)
      }
    },
    'form.reportType': function () {
      if (this.form.customer) {
        // fetch customer sensors
        this.getSensorsByCustomers(this.form.customer)
      }
    },
    'form.locationReportNode': function (val) {
      // fetch customer data
      if (val) {
        this.onLocationChanged(val)
      } else {
        this.deviceGroups = []
        this.customerList = []
      }
    },
    'form.ParamJsonObject.customer': function (val) {
      if (val) {
        // fetch customer sensors
        this.getSensorsByCustomers(val)
      }
    },
    'form.ParamJsonObject.reportType': function () {
      if (this.form.customer) {
        // fetch customer sensors
        this.getSensorsByCustomers(this.form.customer)
      }
    },
    'form.ParamJsonObject.locationReportNode': function (val) {
      // fetch customer data
      if (val) {
        this.onLocationChanged(val)
      } else {
        this.deviceGroups = []
        this.customerList = []
      }
    }
  }
}
